import formatErrorMessage from "../../../utils/formatErrorMessage.js";
import * as React from "react";
const TabsListContext = /* @__PURE__ */ React.createContext(void 0);
if (process.env.NODE_ENV !== "production") TabsListContext.displayName = "TabsListContext";
function useTabsListContext() {
  const context = React.useContext(TabsListContext);
  if (context === void 0) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsListContext is missing. TabsList parts must be placed within <Tabs.List>." : formatErrorMessage(65));
  }
  return context;
}
export {
  TabsListContext,
  useTabsListContext
};
//# sourceMappingURL=TabsListContext.js.map
